import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState, useEffect } from "react";
import { setFilter, filterListener } from "./utils";
import { MultipleSelect } from "../forms";
import { StatusMessage, PopUpMessage } from "../index";
function FilterBoolean(props) {
    const { attribute, componentId, rename, zone, setZone, delay } = props;
    const [values, setValues] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [timeoutValue, setTimeoutValue] = useState(null);
    const [errorMessage, _] = useState("");
    const operator = "in_list";
    useEffect(() => {
        errorMessage && PopUpMessage({ message: errorMessage, type: "error" });
    }, [errorMessage]);
    const flipValues = (val) => {
        const convertedValues = [];
        for (const v of val) {
            switch (v) {
                case "True":
                    convertedValues.push("true");
                    continue;
                case "true":
                    convertedValues.push("True");
                    continue;
                case "False":
                    convertedValues.push("false");
                    continue;
                case "false":
                    convertedValues.push("False");
                    continue;
            }
        }
        return convertedValues;
    };
    filterListener({
        attribute: attribute,
        componentId: componentId,
        operators: [operator],
        zone: zone,
        setValue: setValues,
        setDisabled: setDisabled,
        emptyValue: [],
        zoneToValue: (filterValue) => {
            return flipValues(filterValue);
        },
    }, [zone]);
    const onFilter = (input) => {
        setValues(input);
        clearTimeout(timeoutValue);
        setTimeoutValue(setTimeout(() => {
            setValues(input);
            setFilter({
                operator: operator,
                value: flipValues(input),
                negate: false,
                attribute: attribute,
                componentId: componentId,
                zone: zone,
                valueExists: input.length !== 0,
            });
            setZone({ ...zone });
        }, delay ?? 800));
    };
    const renderItem = (label) => {
        switch (label) {
            case "True":
                return _jsx(StatusMessage, { message: "True", status: "success" });
            case "False":
                return _jsx(StatusMessage, { message: "False", status: "error" });
        }
    };
    const renderValue = (val) => {
        return val.map((v) => {
            return _jsx("div", { children: renderItem(v) }, v);
        });
    };
    return (_jsx("span", { className: "tol-boolean-filter", children: _jsx(MultipleSelect, { block: true, noSearch: true, data: ["True", "False"], placeholder: rename, disabled: disabled, value: values, setValue: onFilter, onClick: (e) => e.stopPropagation(), renderMenuItem: renderItem, renderValue: renderValue }) }));
}
export default FilterBoolean;
